import React, { Component, useState } from "react";
import plus from "../../Assets/img/Competitive/plus-red.png";
import minus from "../../Assets/img/Competitive/minus-red.png";
function FaqTabs(props) {
	console.log(props);
	const [selected, setSelected] = useState(props.selected || null);

	function handleChange() {
		setSelected(null);
	}

	return (
		<div>
			{props.children.map((elem, index) => {
				let style = index === selected ? "selected" : "";
				return (
					<div
					//   style={{ borderBottom: "1px solid black" }}
					>
						<li
							style={{
								fontSize: "1.8vw",
								display: "block",
								// textAlign: "center",
								// margin: "auto",
								position: "relative",
								left: "14%",
								marginRight: "14vw",
								fontWeight: "bold",
								padding: "2%",
							}}
							key={index}
						>
							{index == selected ? (
								<div
									onClick={() => {
										setSelected(null);
									}}
								>
									<img
										style={{ width: "40px" }}
										src={minus}
									/>
									&nbsp; &nbsp;&nbsp;
									{elem.props.title}
								</div>
							) : (
								<div onClick={() => setSelected(index)}>
									{" "}
									<img
										style={{ width: "40px" }}
										// src="https://img.icons8.com/android/24/fa314a/plus.png"
										src={plus}
									/>
									&nbsp; &nbsp;&nbsp;
									{elem.props.title}
								</div>
							)}
							{/* &nbsp; &nbsp;
              {elem.props.title} */}
						</li>
						{index == selected && (
							<div style={{ width: "60%", margin: "auto" }}>
								{props.children[selected]}
							</div>
						)}
						<hr
							style={{
								margin: "auto",
								width: "60%",
								color: "gray",
								height: "3px",
							}}
						/>
					</div>
				);
			})}
		</div>
	);
}

export default FaqTabs;
